export default __webpack_public_path__ + "static/Buzz-7a0342bff7d738934ee0f872f91f25ad.jpg";